import React, { useState } from "react";
import GoogleLoginButton from "./GoogleLoginButton";
import { LOGIN_URL_3P, VERSION } from "../../constants/index.js";

async function loginUser(url, credentials) {
    return fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(credentials),
    })
        .then((response) => {
            if (!response.ok) {
                console.log("login response not ok");
                throw Error(response.statusText);
            }
            return response;
        })
        .then((data) => data.json())
        .catch((error) => {
            console.log("login catch error");
            console.log(error);
            return { status: 102 };
        });
}

const Login = ({
    resolveLogin,
    userAccount,
    logoPath,
    logoTransparent,
    accountName,
}) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    const attemptLogin = async (url, credentials) => {
        setErrorMsg("");
        const loginInfo = await loginUser(url, credentials);
        const { status, message = "" } = loginInfo || {};
        if (status === 0) {
            setBusy(false);
            resolveLogin(loginInfo);
        } else {
            let msg = "";
            switch (`${status}`) {
                case "101":
                    msg = "One or more servers are not available";
                    break;
                case "102":
                    msg = "Server error, please try again";
                    break;
                case "103":
                    msg = "Error connecting to database.";
                    break;
                case "104":
                    msg = "Database query error";
                    break;
                case "105":
                    msg = "Query results empty error";
                    break;
                case "106":
                    msg =
                        "Username and/or password incorrect, please try again!";
                    break;
                case "109":
                    msg = "User validation failed";
                    break;
                case "110":
                    msg = "General error, resource not found";
                    break;
                case "201":
                    msg =
                        "User/password login disabled, please use Google button";
                    break;
                case "999":
                    msg = message;
                    break;
                default:
                    msg = "Unknown error";
            }

            setBusy(false);
            setErrorMsg(msg);
        }
    };

    const handleSubmit = (e) => {
        // todo: pick url by account
        setBusy(true);
        e.preventDefault();
        const loginUrl = `${LOGIN_URL_3P}/${userAccount}`;
        attemptLogin(loginUrl, {
            username,
            password,
        });
    };

    const thisYear = new Date().getFullYear();
    const useGoogleSignin = userAccount === "abra";

    return (
        <main className="login-page">
            <div className="login-container">
                <div className="brand">
                    <img
                        src={logoPath}
                        alt={accountName}
                        className={
                            logoTransparent
                                ? "brand-logo"
                                : "brand-logo bordered"
                        }
                        title={VERSION}
                    />
                </div>

                <section className="login-panel" aria-label="Sign in">
                    {errorMsg !== "" && (
                        <div className="login-error">{errorMsg}</div>
                    )}

                    {useGoogleSignin ? (
                        <GoogleLoginButton onLoginSuccess={resolveLogin} />
                    ) : (
                        <form className="login-form" onSubmit={handleSubmit}>
                            <input
                                type="email"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                placeholder="Email"
                                autoComplete="email"
                                required
                                disabled={busy}
                            />
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Password"
                                autoComplete="current-password"
                                required
                                disabled={busy}
                            />
                            <button type="submit" disabled={busy}>
                                Sign In
                            </button>
                        </form>
                    )}

                    <footer className="login-footer">
                        <a href="mailto:support@abracontrols.com">
                            Support: support@abracontrols.com
                        </a>

                        <span>&copy; 2010-{thisYear} Abra Controls. Inc </span>
                    </footer>
                </section>
            </div>
        </main>
    );
};

export default Login;
